import React from 'react';

import HeroBig from '../../../components/HeroBig';

import './style.scss';

const ParagraphCtaCampaign = ({ id, entity, wide }) => {
  const donationParagraph = entity.getIn(['field_donation_paragraph', 0], null);

  return (
    <div id={id} className="ParagraphCtaCampaign">
      <HeroBig
        entity={entity}
        hideAlButtons={donationParagraph !== null}
        donationParagraph={donationParagraph}
      />
    </div>
  );
};

export default ParagraphCtaCampaign;
